import * as signalR from '@microsoft/signalr';
import Config from './config';

class SefazFilaSignalRService {
	constructor() {
		this.connection = null;
		this.onAtualizada = null;
		this.reconnectTimer = null;
	}

	getHubUrl() {
		const baseUrl = Config.urls.API_URL_BASE.replace('/api/', '');
		const codUsuario = localStorage.getItem('CodUsuario');

		return `${baseUrl}/ws/sefazfilahub?codUsuario=${codUsuario}`;
	}

	async start({ onAtualizada }) {
		this.onAtualizada = onAtualizada;

		if (this.connection && this.connection.state === signalR.HubConnectionState.Connected) return;
		if (this.connection && this.connection.state === signalR.HubConnectionState.Connecting) return;

		this.connection = new signalR.HubConnectionBuilder()
			.withUrl(this.getHubUrl(), {
				accessTokenFactory: () => localStorage.getItem('AccessToken'),
				transport: signalR.HttpTransportType.ServerSentEvents,
			})
			.withAutomaticReconnect()
			.configureLogging(signalR.LogLevel.Error)
			.build();

		this.connection.serverTimeoutInMilliseconds = 120000;
		this.connection.keepAliveIntervalInMilliseconds = 30000;

		this.connection.on('SefazFilaAtualizada', evento => {
			if (this.onAtualizada) this.onAtualizada(evento);
		});

		this.connection.onclose(() => {
			this.connection = null;
			this.scheduleReconnect();
		});

		try {
			await this.connection.start();
		} catch (err) {
			console.error('Erro ao conectar SignalR fila SEFAZ:', err);
			this.connection = null;
			this.scheduleReconnect();
		}
	}

	scheduleReconnect() {
		if (this.reconnectTimer || !this.onAtualizada) return;

		this.reconnectTimer = setTimeout(() => {
			this.reconnectTimer = null;
			this.start({ onAtualizada: this.onAtualizada });
		}, 5000);
	}

	async stop() {
		if (this.reconnectTimer) {
			clearTimeout(this.reconnectTimer);
			this.reconnectTimer = null;
		}

		if (this.connection) {
			try {
				await this.connection.stop();
			} catch (err) {
				console.error('Erro ao desconectar SignalR fila SEFAZ:', err);
			}

			this.connection = null;
		}
	}
}

const sefazFilaSignalR = new SefazFilaSignalRService();
export default sefazFilaSignalR;
